import { render, staticRenderFns } from "./Im.vue?vue&type=template&id=2b4cb1df&scoped=true&"
import script from "./Im.vue?vue&type=script&lang=js&"
export * from "./Im.vue?vue&type=script&lang=js&"
import style0 from "./Im.vue?vue&type=style&index=0&id=2b4cb1df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cb1df",
  null
  
)

export default component.exports